import { SiteEventEdit } from '@/api/site';
import { trim } from '@/libs/utils';

export default {
  data() {
    return {
      // 站点编辑搜索
      stationEditSearch: {
        date: null,
        keyword: '',
      },
      stationEditSearchDate: null,

      // 站点编辑数据
      stationEditData: null,

      // 分页
      stationEditPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },

      // 站点编辑表头
      stationEditColumns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          width: 60,
          dataIndex: 'id',
        },
        {
          title: this.$t('com_table_data'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('site_table_user'),
          dataIndex: 'executeUserName',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('logs_table_action_type'),
          dataIndex: 'updateType',
          scopedSlots: { customRender: 'updateType' },
          align: 'center',
        },

        {
          title: this.$t('logs_table_execute_time'),
          dataIndex: 'executeTime',
          scopedSlots: { customRender: 'executeTime' },
          sorter: true,
          align: 'center',
        },
      ],

      tableLoading: false,
    };
  },

  methods: {
    // date picker change
    stationEditDateChange(value) {
      this.stationEditPagination.current = 1;

      if (value && value.length === 2) {
        const _startDate = value[0].startOf('day').valueOf();
        const _endData = value[1].endOf('day').valueOf();
        this.stationEditSearch.date = `${_startDate}-${_endData}`;
      } else {
        this.stationEditSearch.date = undefined;
      }
      this.getStationEditData();
    },

    // 获取站点编辑数据
    getStationEditData() {
      this.tableLoading = true;
      const params = {
        // 默认为1，即倒序
        orderType: 1,
        ...this.stationEditSearch,
        pageSize: this.stationEditPagination.pageSize,
        pageNo: this.stationEditPagination.current,
        stationId: this.stationId,
      };

      // 去掉空格
      if (params.keyword) {
        params.keyword = trim(params.keyword);
      }

      SiteEventEdit(params)
        .then(res => {
          if (res.code === 0) {
            this.stationEditData = res.data;
            this.stationEditPagination.total = res.totalCount;
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    // reset
    resetStationEditSearch() {
      this.stationEditPagination.current = 1;
      this.stationEditSearchDate = null;
      this.stationEditSearch = {
        startDate: null,
        endDate: null,
        name: '',
      };

      this.getStationEditData();
    },

    // page change
    stationEditPageChange(page) {
      this.stationEditPagination.current = page;
      this.getStationEditData();
    },

    // 表格排序
    handleStationEditTableChange(pagination, filters, sorter) {
      const { field, order } = sorter;

      // orderField:"排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间",
      // orderType:"排序类型, 0为升序，1为倒序",
      if (field === 'id') {
        this.stationEditSearch.orderField = 0;
      } else if (field === 'updateType') {
        this.stationEditSearch.orderField = 1;
      } else if (field === 'executeUser') {
        this.stationEditSearch.orderField = 2;
      } else if (field === 'executeTime') {
        this.stationEditSearch.orderField = 3;
      }
      this.stationEditSearch.orderType = order === 'ascend' ? 0 : 1;

      this.getStationEditData();
    },
  },
};
